import styles from "../../styles/info/Legal.module.css";
import data from "../../data/legal.json";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function Legal() {
  // 관련 법규
  return (
    <div className={cx("legalContainer")}>
      <div className={cx("title")}>
        <h4>{data.title}</h4>
      </div>

      {data.sections.map((section, i) => (
        <div key={i} className={cx("legalSection")}>
          {/* 카테고리 */}
          <h5 className={cx("legalCategory")}>{section.category}</h5>

          <div className={cx("legalScrollBox")}>
            {/* 조문 리스트 */}
            {section.items.map((item, j) => (
              <div key={j} className={cx("article")}>
                <h5 className={cx("articleTitle")}>{item.title}</h5>

                {item.content && (
                  <ul className={cx("legalContentList")}>
                    {item.content.map((text, k) => (
                      <li key={k}>{text}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
